<template>
  <div>
    <van-popup v-model="showEquipmentLease" class="backRect" get-container="body" @closed="onClosed">
      <TopBar :pagetitle="title" :is-left-self="true" class="flexTop" @leftClick="onBack" />
      <div class="fullRect">
        <div class="fastRect">
          <div class="title">可租赁项目<span>请选择您需要租赁的装备、规格、时长。</span></div>
          <div v-for="(item,index) in equipmentLeaseItemList" :key="item.equipmentLeaseId" class="itemRect">
            <van-row>
              <van-col span="12"><van-checkbox v-model="equipmentLeaseItemList[index].checked" @change="updateTotalPrice">{{ item.title }}</van-checkbox></van-col>
              <van-col span="12" class="priceInfo"><b>{{ item.priceCurrency }}</b> {{ ShowMoney(item.price) }} / {{ item.priceUnit }}</van-col>
            </van-row>
            <template v-if="equipmentLeaseItemList[index].checked">
              <van-row gutter="20">
                <van-col span="6" class="countLine"><span>租期 <b>{{ item.priceUnit }}</b></span></van-col>
                <van-col span="18"><van-stepper v-model="equipmentLeaseItemList[index].count" style="display: inline-block;" @change="updateTotalPrice" /></van-col>
              </van-row>
              <van-row v-if="item.specificationOption.length>0" gutter="20" class="specificationLineRect">
                <van-col span="6" class="specificationLine"><span>规格<span v-if="item.isMustSpecifications" style="color:#f00">*</span></span></van-col>
                <van-col span="18">
                  <van-radio-group v-model="equipmentLeaseItemList[index].specification" direction="horizontal">
                    <van-radio v-for="(option,optIndex) in item.specificationOption" :key="index+'a'+optIndex" :name="option">{{ option }}</van-radio>
                  </van-radio-group>
                </van-col>
              </van-row>
            </template>
            <div v-if="item.about" class="aboutEquipmentLease">{{ item.about }}</div>
          </div>
          <div class="itemRect">
            <van-row>
              <van-col span="12"><van-checkbox v-model="unEquipmentLease" @change="onUnEquipmentLease">无需租赁</van-checkbox></van-col>
              <van-col span="12" />
            </van-row>
            <div class="aboutEquipmentLease">如无需任何需求，请勾选后提交</div>
          </div>
        </div>
        <div class="emptyRect" />
        <div class="downButtonBase">
          <van-row gutter="10">
            <van-col span="16" class="priceLine">
              <div v-html="totalPrictHtml" />
            </van-col>
            <van-col span="8"> <van-button type="danger" size="large" :color="GetColorMain()" style="width:100%" :loading="buttonLoading" loading-text="提交中..." @click="editEquipmentLease">提交</van-button></van-col>
          </van-row>

        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Popup, Area, Uploader, Dialog, Checkbox, Stepper, RadioGroup, Radio } from 'vant'
import TopBar from '@/components/TopBar'
import { groupBy, isEmptyStr, ShowMoney, GetEnumText, formatDate, MyNotify } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Area.name]: Area,
    [Uploader.name]: Uploader,
    [Dialog.name]: Dialog,
    [Checkbox.name]: Checkbox,
    [Stepper.name]: Stepper,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    TopBar
  },
  props: {
    // eslint-disable-next-line
    value:undefined,
    // eslint-disable-next-line
    showType:undefined
  },
  data() {
    return {
      showEquipmentLease: undefined,
      title: '选择租赁装备',
      buttonLoading: false,
      studentId: undefined, // 行程顾客序号
      equipmentLeaseItemList: [],
      unEquipmentLease: true,
      totalPrictHtml: ''
    }
  },
  watch: {
    value(newValue) {
      if (newValue !== null && newValue !== undefined) {
        this.studentId = newValue
        this.showEquipmentLease = true
        this.init()
      } else {
        this.studentId = undefined
        this.showEquipmentLease = false
      }
    }
  },

  created() {
    // this.customerInfoDataBaseSave = JSON.parse(JSON.stringify(this.customerInfoDataBase))
  },
  methods: {
    MyNotify,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    isEmptyStr,
    onClosed() {
      this.studentId = undefined
      this.$emit('input', undefined)
    },
    onBack() {
      this.showEquipmentLease = false
      return true
    },
    init() {
      this.initUserEquipmentLeaseList()
      this.updateTotalPrice()
    },
    onUnEquipmentLease() {
      if (this.unEquipmentLease) {
        this.equipmentLeaseItemList.forEach(el => {
          el.checked = false
        })
      }
      this.updateTotalPrice()
    },
    updateTotalPrice() {
      this.equipmentLeaseItemList.forEach(el => {
        if (el.checked) {
          this.unEquipmentLease = false
        }
      })

      this.totalPrictHtml = '<span>总计</span>'
      var group = groupBy(this.equipmentLeaseItemList, (link) => {
        return link.priceCurrency
      })
      var haveAnyOne = false
      for (const key in group) {
        var gl = group[key]
        var price = 0
        var priceCurrency = ''
        gl.forEach(item => {
          if (item.checked) {
            price += item.count * item.price
            priceCurrency = item.priceCurrency
          }
        })
        if (price > 0) {
          haveAnyOne = true
          this.totalPrictHtml += '<span><b>' + priceCurrency + '</b>' + ShowMoney(price) + '</span> '
        }
        if (!haveAnyOne) {
          this.totalPrictHtml += '<span><b>CNY</b>0.00</span> '
        }
      }
    },
    initUserEquipmentLeaseList(callback) {
      if (!this.studentId) {
        if (callback) {
          callback()
        }
        return
      }
      request({
        url: '/DiveTrip/GetUserEquipmentLeaseList',
        method: 'post',
        params: {
          id: this.studentId
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        response.data.forEach(el => {
          el.checked = false
          el.count = 1
          el.specification = ''
          if (el.specifications) {
            el.specificationOption = el.specifications.split(',')
          } else {
            el.specificationOption = []
          }
        })
        this.equipmentLeaseItemList = JSON.parse(JSON.stringify(response.data))
        if (callback) {
          callback()
        }
      })
    },
    editEquipmentLease() {
      var isPass = true
      this.equipmentLeaseItemList.forEach(el => {
        if (el.checked) {
          if (el.isMustSpecifications && el.specificationOption.length > 0) {
            if (!el.specification) {
              MyNotify('info', el.title + '必须选择规格')
              isPass = false
            }
          }
        }
      })
      if (!isPass) {
        return
      }
      this.buttonLoading = true
      var postData = {
        studentId: this.studentId,
        list: []
      }
      this.equipmentLeaseItemList.forEach(el => {
        if (el.checked) {
          postData.list.push({
            equipmentLeaseId: el.equipmentLeaseId,
            count: el.count,
            specifications: el.specification
          })
        }
      })
      request({
        url: '/DiveTrip/updateUserEquipmentLease',
        method: 'post',
        data: postData
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '选择租赁装备成功', 3000)
        this.$emit('reload')
        this.showEquipmentLease = false
      })
    }

  }
}
</script>
<style scoped>
.fullRect{
  height: calc(100vh - 3em);
  overflow-y: scroll;
}
.backRect{
    width: 100vw;
    height: 100vh;
    background-color: #F1f1f1;
}
.downButton{
    margin: 1em;
}
.emptyRect{
    height: 3em;
}
.downButtonBase{
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  height: 3em;
  background-color: #fff;
}
.downButtonBase .priceLine{
    line-height: 3em;
    text-align: right;
}
.downButtonBase .priceLine div{
    font-size: 0.8em;
}
.fastRect{
    background-color: #fff;
    border-radius: 0.3em;
    padding: 0.5em;
    margin: 1em;
}
.fastRect .title{
    font-size: 1.1em;
    font-weight: 700;
    padding: 0.3em 0 0.3em 0.9em;
}
.fastRect .title span{
  font-size: 0.7em;
  color: #999;
  padding-left: 0.4em;
  font-weight: 400;
}
.itemRect{
    border-bottom:1px solid #f5f5f5;
    margin-bottom: 0.5em;
    padding-bottom:0.5em;
}
.itemRect .priceInfo{
    font-size: 0.7em;
    color: #999;
    text-align: right;
}
.itemRect .aboutEquipmentLease{
    font-size: 0.7em;
    color: #999;
    padding: 0.5em 0;
}
.itemRect .countLine{
    line-height: 28px;
    text-align: right;
}
.itemRect .countLine span{
    font-size: 0.8em;
}
.itemRect .specificationLineRect{
    padding: 0.5em 0;
    text-align: right;
}
.itemRect .specificationLine span{
    font-size: 0.8em;
}
</style>
